export enum DocumentResultType {
  Letter = "letter",
  Document = "document",
  InboundFax = "inbound_fax",
}

export const DOCUMENT_RESULT_TYPE_TEXT_LABEL: Record<DocumentResultType, string> = {
  [DocumentResultType.Letter]: "Letter",
  [DocumentResultType.Document]: "Document",
  [DocumentResultType.InboundFax]: "Inbound Fax",
};

export const DOCUMENT_RESULT_TYPE_TEXT_LABEL_PLURAL: Record<DocumentResultType, string> = {
  [DocumentResultType.Letter]: "Letters",
  [DocumentResultType.Document]: "Documents",
  [DocumentResultType.InboundFax]: "Inbound Faxes",
};

export const DOCUMENT_METHOD_LABEL = {
  fax: "Fax",
  provider_portal: "Provider Portal",
  emr: "EMR",
  email: "Email",
  mail: "Mail",
  external_vendor: "External Vendor",
} as const;

export type DocumentMethod = keyof typeof DOCUMENT_METHOD_LABEL;
